module.exports = __webpack_public_path__ + "e43b659879af932151a45a158d5cae32.png";